export interface UserGroup {
    id?: number;
    groupName: string;
    organizationId?: number | string;
    roles?: string[];
    userIds?: Array<number | string>;
}

export interface GroupMember {
    id: number;
    userId?: string;
    fullName?: string;
    email?: string;
    active?: boolean;
}

export interface UserGroupBaseline {
    groupName: string;
    userIds: string[];
    roles: string[];
}

export interface SaveUserGroupPayload {
    id?: number;
    groupName: string;
    organizationId?: number | string;
    userIds: string[];
    roles: string[];
}

export function memberLabel(member: Pick<GroupMember, 'fullName' | 'userId' | 'email'>) {
    const name = member.fullName || member.userId || '';
    return `${name} (${member.email ?? ''})`;
}

export function sentenceCase(label: string) {
    const words = label.split(' ');
    const isTitleCase = words.length > 1 && words.every((word) => /^[A-Z][a-z]*$/.test(word));
    if (!isTitleCase) {
        return label;
    }
    return [words[0], ...words.slice(1).map((word) => word.toLowerCase())].join(' ');
}

export function sameValues(left: string[], right: string[]) {
    if (left.length !== right.length) {
        return false;
    }
    const sortedLeft = [...left].sort();
    const sortedRight = [...right].sort();
    return sortedLeft.every((value, index) => value === sortedRight[index]);
}
